import { LoginResponse, SSOResponse, TAndCResponse } from '../models/commonModels';
import fetch, { getAuthorizationHeaders } from './fetch';

export default ({ emailDomain }: { emailDomain: string }): Promise<SSOResponse> =>
    fetch<SSOResponse>('/sso/lookup', {
        method: 'POST',
        body: JSON.stringify({ emailDomain }),
    });

export const tokenExchange = ({ clientId, authCode }: { clientId: string; authCode: string }): Promise<LoginResponse> =>
    fetch<LoginResponse>(
        '/token',
        {
            method: 'POST',
            body: JSON.stringify({
                code: authCode,
                grant_type: 'federated_code_grant',
                client_id: clientId,
            }),
        },
        { isRefreshing: 'true' }
    );

export const checkTermsAndConditions = (): Promise<TAndCResponse> =>
    fetch('/sso/terms-and-conditions', {
        headers: getAuthorizationHeaders(),
        method: 'GET',
    });

export const setTermsAndConditions = (): Promise<void> =>
    fetch('/sso/terms-and-conditions', {
        headers: getAuthorizationHeaders(),
        method: 'PATCH',
    });
